export function getAttractions (theme, status) {
  return new Promise((resolve, reject) => {
		let url = `/attractions.json?siteId=${window.currentSiteHandle}`;
		if (theme) url += `&theme=${theme}`;
		if (status) url += `&status=${status}`;

		fetch(url)
		.then(data => data.json())
		.then((data) => {
			resolve(data);
		})
		.catch((error) => {
			reject(error);
		});
  });
}

export function getCourses () {
  return new Promise((resolve, reject) => {
		fetch('/courses.json?siteId=' + window.currentSiteHandle)
		.then(data => data.json())
		.then((data) => {
			resolve(data);
		})
		.catch((error) => {
			reject(error);
		});
  });
}

export function getCourseAttractions (id) {
	return new Promise((resolve, reject) => {
		console.log({id});
		fetch('/course-attractions/' + id + '.json?siteId=' + window.currentSiteHandle)
		.then(data => data.json())
		.then((data) => {
			resolve(data);
		})
		.catch((error) => {
			reject(error);
		});
  });
}

export function getCoursesSimple () {
  return new Promise((resolve, reject) => {
		fetch('/courses-simple.json?siteId=' + window.currentSiteHandle)
		.then(data => data.json())
		.then((data) => {
			resolve(data);
		})
		.catch((error) => {
			reject(error);
		});
  });
}




function checkRes (response) {
	// if (response.ok) return response.json();
	// throw response;
	return response.json();
}

export function recommendEntry (entryId) {
	const formData = new FormData();
	formData.set('data', JSON.stringify({entryId: entryId}));
	formData.set(window.csrfTokenName, window.csrfTokenValue);

	return new Promise((resolve, reject) => {
		fetch('/actions/user-recommendations/recommendations/recommend', {
			method: 'post',
			body: formData
		})
		.then(checkRes)
		.then((data) => {
			resolve(data);
		})
		.catch((error) => {
			reject(error);
		});
  });
}

export function unrecommendEntry (entryId) {
	const formData = new FormData();
	formData.set('data', JSON.stringify({entryId: entryId}));
	formData.set(window.csrfTokenName, window.csrfTokenValue);
  return new Promise((resolve, reject) => {
		fetch('/actions/user-recommendations/recommendations/unrecommend', {
			method: 'post',
			body: formData
		})
		.then(data => data.json())
		.then((data) => {
			resolve(data);
		})
		.catch((error) => {
			reject(error);
		});
  });
}
